import { Transforms } from 'slate'
import { ElementTypes } from '../types'
import { getNode } from './editor'

export function insertCodiQuote(editor, params) {
  const node = {
    children: [{ text: '' }],
    type: ElementTypes.CODI_QUOTE,
    ...(params ?? {}),
  }
  Transforms.insertNodes(editor, node, {
    select: true,
  })
}

export function updateCodiQuote(editor, params) {
  const { selection } = editor
  if (!!selection) {
    const node = getNode(editor, ElementTypes.CODI_QUOTE)
    if (node) {
      const [__, path] = node
      Transforms.setNodes(editor, params ?? {}, { at: path })
    }
  }
}

export function removeCodiQuote(editor, options) {
  const { selection } = editor
  if (!!selection) {
    Transforms.removeNodes(editor, options)
  }
}
